var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tipoCadastro === "ONEROSO" ||
      _vm.cadastroFormulario.tipo === "ONEROSO"
        ? _c(
            "el-row",
            { staticClass: "radio-buttons", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: true },
                      model: {
                        value:
                          _vm.cadastroFormulario.interessado.pessoa
                            .isPessoaFisica,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.cadastroFormulario.interessado.pessoa,
                            "isPessoaFisica",
                            $$v
                          )
                        },
                        expression:
                          "cadastroFormulario.interessado.pessoa.isPessoaFisica"
                      }
                    },
                    [_vm._v("Pessoa Física")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: false },
                      model: {
                        value:
                          _vm.cadastroFormulario.interessado.pessoa
                            .isPessoaFisica,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.cadastroFormulario.interessado.pessoa,
                            "isPessoaFisica",
                            $$v
                          )
                        },
                        expression:
                          "cadastroFormulario.interessado.pessoa.isPessoaFisica"
                      }
                    },
                    [_vm._v("Pessoa Jurídica")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.cadastroFormulario.interessado &&
      _vm.cadastroFormulario.interessado.pessoa &&
      _vm.cadastroFormulario.interessado.pessoa.isPessoaFisica
        ? _c("app-pessoa-fisica-retificacao", {
            attrs: { nomeAba: "Interessado", observer: _vm.observer },
            on: {
              changeEstadoCivil: _vm.getEstadoCivil,
              changePossuiCertidaoObito: _vm.possuiCertidaoObito,
              usarDadosCadastrante: _vm.usarDadosCadastrante
            }
          })
        : _vm._e(),
      _vm.cadastroFormulario.interessado &&
      _vm.cadastroFormulario.interessado.pessoa &&
      !_vm.cadastroFormulario.interessado.pessoa.isPessoaFisica
        ? _c("app-pessoa-juridica", {
            attrs: {
              pessoa: _vm.cadastroFormulario.interessado.pessoa,
              nomeAba: "Interessado",
              observer: _vm.observer
            }
          })
        : _vm._e(),
      _vm.enderecoInteressado
        ? _c("app-endereco-retificacao", {
            attrs: { endereco: _vm.enderecoInteressado, nomeAba: "Interessado" }
          })
        : _vm._e(),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _vm.tiposDocumentos.length
                ? _c("app-documentos-retificacao", {
                    attrs: {
                      maxSize: 20,
                      "valid-extensions": _vm.extensoes,
                      documentos: _vm.documentosInteressado,
                      tiposDocumentos: _vm.tiposDocumentos,
                      tiposDocumentosObrigatorios: _vm.tiposDocumentos,
                      observer: this.$refs.validation,
                      isDocumentoImagex: true,
                      titulo: "Documentação",
                      aba: "Interessado",
                      idUploadDocumento: "appUploadDocumentosInteressado"
                    },
                    on: {
                      addedDoc: _vm.handleDocs,
                      removedDoc: _vm.removerDocs
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.cadastroFormulario.interessado &&
      _vm.cadastroFormulario.interessado.pessoa &&
      !_vm.cadastroFormulario.interessado.pessoa.isPessoaFisica
        ? _c("app-socio-retificacao", {
            attrs: {
              socios:
                _vm.cadastroFormulario.interessado.sociosRepresentantesLegais,
              idProcesso: Number(_vm.idProcesso)
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dc8a780", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dc8a780","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/Interessado.vue
// module id = null
// module chunks = 